import React from 'react';
import PropTypes from 'prop-types';
import HiringCapacityCheckBox from './HiringCapacityCheckBox';

function HiringCapacityFilter({ hiringCapacities, onHiringCapacityToggle }) {
  return (
    <div>
      {hiringCapacities.map((hiringCapacity) => (
        <HiringCapacityCheckBox
          key={hiringCapacity.type}
          hiringCapacity={hiringCapacity}
          onHiringCapacityToggle={() => onHiringCapacityToggle(hiringCapacity)}
          checked={hiringCapacity.isChecked}
        />
      ))}
    </div>
  );
}

HiringCapacityFilter.propTypes = {
  hiringCapacities: PropTypes.array,
  onHiringCapacityToggle: PropTypes.func,
};

HiringCapacityFilter.defaultProps = {
  hiringCapacities: null,
  onHiringCapacityToggle: null,
};

export default HiringCapacityFilter;
